import http from 'helpers/http';

import type { IUser, IUserLogin, IUserRegister, IUserWithToken } from 'models/Auth';

export const serviceAuth = {
  whoAmI: () => http.get<IUser>('/auth/whoami'),
  login: (userLogin: IUserLogin) => http.post<IUserWithToken>('/auth/login', userLogin),
  register: (userRegister: IUserRegister) => http.post<IUser>('/auth/register', userRegister),
};
